import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser4Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C17.5228 2 22 6.47715 22 12C22 14.4016 21.1534 16.6055 19.7424 18.3294L19.7617 18.3521L19.6304 18.4638C17.7961 20.627 15.0584 22 12 22C9.05085 22 6.39987 20.7233 4.56956 18.6925L4.3696 18.4638L4.23825 18.3521L4.25763 18.3294C2.8466 16.6055 2 14.4016 2 12C2 6.47715 6.47715 2 12 2ZM12 17C10.1403 17 8.45892 17.5921 7.20656 18.4055C8.54249 19.4068 10.202 20 12 20C13.798 20 15.4575 19.4068 16.7934 18.4055C15.5411 17.5921 13.8597 17 12 17ZM12 4C7.58172 4 4 7.58172 4 12C4 13.8847 4.65173 15.6172 5.74211 16.9843C7.36303 15.8211 9.57491 15 12 15C14.4251 15 16.637 15.8211 18.2579 16.9843C19.3483 15.6172 20 13.8847 20 12C20 7.58172 16.4183 4 12 4ZM12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8Z",
		fill: "currentColor"
	})
});
export default SvgUser4Line;
